import {createSelector} from '@reduxjs/toolkit';
import {AppUserGroup} from 'store/slices/app/types';
import type {Store} from 'store';

const x = (store: Store) => store;

export const isLoaded = createSelector(x, store => store.app.loaded);
export const isActive = createSelector(x, store => store.app.active);
export const isLoggedIn = createSelector(x, store => !!store.app.user);
export const isPremium = createSelector(x, store => store.app.user && store.app.user.group >= AppUserGroup.Pro);
export const isBusiness = createSelector(x, store => store.app.user && store.app.user.group === AppUserGroup.Business);
export const isTrial = createSelector(x, store => store.app.user && !store.app.user.email);

export const getUser = createSelector(x, store => store.app.user);
export const getName = createSelector(x, store => store.app.user && store.app.user.name);
export const getEkey = createSelector(x, store => store.app.user && store.app.user.ekey);
export const getEmail = createSelector(x, store => store.app.user && store.app.user.email);
export const getLimits = createSelector(x, store => store.app.user && store.app.user.limit);
export const getAvatar = createSelector(x, store => store.app.user && store.app.user.avatar);
export const getRevision = createSelector(x, store => store.app.revision);
export const getHeader = createSelector(x, store => store.app.user && store.app.user.header);
export const getNotifications = createSelector(x, store => store.app.notifications);
